<div *ngIf="nav.paletteOpen()"
  class="fixed inset-0 z-[70] bg-slate-900/40 backdrop-blur-sm flex items-stretch md:items-start justify-center md:pt-[12vh]"
  (click)="nav.closePalette()">
  <div (click)="$event.stopPropagation()"
    class="w-full md:w-[640px] md:max-w-[92vw] h-full md:h-auto flex flex-col overflow-hidden
           bg-white/95 dark:bg-slate-900/95 md:rounded-2xl md:border border-slate-100 dark:border-slate-800 shadow-2xl animate-fade-in-up">

    <div class="flex items-center gap-3 px-4 py-3 border-b border-slate-100 dark:border-slate-800 shrink-0">
      <span class="material-icons text-slate-400">search</span>
      <input #paletteInput type="text" [value]="query()" (input)="onQueryInput($event)"
        placeholder="พิมพ์ชื่อเมนู เช่น ใบแจ้งหนี้, stamp, rpfi..."
        class="flex-1 min-w-0 bg-transparent outline-none text-base md:text-[15px] text-slate-800 dark:text-slate-100 placeholder:text-slate-400" />
      <kbd class="hidden md:inline text-[11px] bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded px-1.5 py-0.5 text-slate-500">Esc</kbd>
      <button type="button" (click)="nav.closePalette()" class="md:hidden text-sm text-slate-500 px-1">ยกเลิก</button>
    </div>

    <div #paletteList class="flex-1 md:flex-none md:max-h-[56vh] overflow-y-auto custom-scrollbar pb-2">
      <ng-container *ngFor="let section of sections()">
        <div class="px-4 pt-3 pb-1 text-[11px] font-semibold text-slate-400">{{ section.title }}</div>
        <button type="button" *ngFor="let row of section.items" [attr.data-idx]="row.index"
          (click)="open(row.leaf)" (mousemove)="setActive(row.index)"
          class="w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors"
          [class.bg-amber-50]="row.index === activeIndex()"
          [class.dark:bg-slate-800]="row.index === activeIndex()">
          <span class="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
            [ngClass]="row.index === activeIndex() ? 'bg-[#facc15] text-[#1f1f20]' : 'bg-slate-100 dark:bg-slate-800 text-slate-500'">
            <span class="material-icons-outlined text-[18px]">{{ row.leaf.icon }}</span>
          </span>
          <span class="flex-1 min-w-0">
            <span class="block text-sm text-slate-800 dark:text-slate-100 truncate">
              <ng-container *ngFor="let part of highlight(row.leaf.name)">
                <mark *ngIf="part.hit; else plain" class="bg-[#facc15] text-[#1f1f20] rounded-sm px-px">{{ part.text }}</mark>
                <ng-template #plain>{{ part.text }}</ng-template>
              </ng-container>
            </span>
            <span class="block text-xs text-slate-400 truncate">
              {{ row.leaf.heading }}<ng-container *ngIf="row.leaf.parentName"> › {{ row.leaf.parentName }}</ng-container>
            </span>
          </span>
          <span *ngIf="row.leaf.live"
            class="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15]/15 text-amber-600 font-bold border border-[#facc15]/30">
            <span class="w-1.5 h-1.5 rounded-full bg-[#facc15] animate-pulse"></span>LIVE
          </span>
          <span *ngIf="isFavorite(row.leaf.id)" class="material-icons text-[16px] text-[#facc15]">star</span>
          <kbd *ngIf="row.index === activeIndex()"
            class="hidden md:inline text-[11px] bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded px-1.5 py-0.5 text-slate-500">Enter</kbd>
        </button>
      </ng-container>

      <div *ngIf="!flatResults().length" class="px-4 py-10 text-center text-sm text-slate-400">
        <span class="material-icons-outlined text-3xl block mb-1 opacity-60">search_off</span>
        <ng-container *ngIf="query().trim(); else emptyHint">ไม่พบเมนูที่ตรงกับ "{{ query().trim() }}"</ng-container>
        <ng-template #emptyHint>พิมพ์เพื่อค้นหาเมนูทั้งระบบ</ng-template>
      </div>
    </div>

    <div class="hidden md:flex items-center gap-4 px-4 py-2 border-t border-slate-100 dark:border-slate-800 text-[11px] text-slate-400">
      <span><kbd class="border border-slate-200 dark:border-slate-700 rounded px-1">↑</kbd> <kbd class="border border-slate-200 dark:border-slate-700 rounded px-1">↓</kbd> เลือก</span>
      <span><kbd class="border border-slate-200 dark:border-slate-700 rounded px-1">Enter</kbd> เปิดหน้า</span>
      <span><kbd class="border border-slate-200 dark:border-slate-700 rounded px-1">Esc</kbd> ปิด</span>
      <span class="ml-auto">ค้นได้ทั้งชื่อไทย และคำอังกฤษ</span>
    </div>
  </div>
</div>
